
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-dining/home",
      function () {
        return require("private-next-pages/private-dining/home.tsx");
      }
    ]);
  